import Vue from 'vue'
import Vuex from 'vuex'
import VuexORM from '@vuex-orm/core'
import VuexORMAxios from '@vuex-orm/plugin-axios'
import { configuredAxios } from '@/dataAccess/api'
import Employee from './models/Employee'
import AccessibleClient from '@/dataAccess/models/AccessibleClient'
import LimitedClient from '@/dataAccess/models/LimitedClient'
import Service from '@/dataAccess/models/Service'

Vue.use(Vuex)
VuexORM.use(VuexORMAxios, { axios: configuredAxios })
// Create a new instance of Database.
const database = new VuexORM.Database()

database.register(Employee)
database.register(LimitedClient)
database.register(AccessibleClient)
database.register(Service)

export class DoesNotExist extends Error {}

export default new Vuex.Store({
  plugins: [VuexORM.install(database)],
  state: {
    user: null,
    employees: [],
    clients: [],
    limitedClients: [],
    services: [],
    locations: [],
    projects: [],
    reloadDestination: ''
  },
  mutations: {
    storeUser(state, user) {
      state.user = user
    },
    reloadDestination(state, reloadDestination) {
      state.reloadDestination = reloadDestination
    }
  },
  actions: {
    storeUser({ commit }, user) {
      commit('storeUser', user)
    },
    reloadDestination({ commit }, reloadDestination) {
      commit('reloadDestination', reloadDestination)
    }
  },
  getters: {
    user(state) {
      return state.user
    },
    reloadDestination(state) {
      return state.reloadDestination // TODO after getting it, clear it from store
    }
  }
})
